import request from '@/utils/request'
const BASE_URL = '/File'

export default {
  getAllList() {
    return request({
      url: BASE_URL + '/GetAllList',
    })
  },
  update(data) {
    return request({
      url: BASE_URL + '/Update',
      method: 'post',
      data
    })
  },
  getSerialNo(fileName, classId) {
    return request({
      url: BASE_URL + '/GetDefaultSerialNo',
      method: 'get',
      params: { fileName, classId }
    })
  }
}